var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { MetricType } from "@madmedical/medical";
import { memo } from "react";
import BloodOxygenChart from "./metric/BloodOxygenChart";
import BloodPressureChart from "./metric/BloodPressureChart";
import BloodSugarChart from "./metric/BloodSugarChart";
import BodyMassIndexChart from "./metric/BodyMassIndexChart";
import BodyTemperatureChart from "./metric/BodyTemperatureChart";
import BodyWeightChart from "./metric/BodyWeightChart";
import DailyStepsChart from "./metric/DailyStepsChart";
import HeartRateVariabilityChart from "./metric/HeartRateVariabilityChart";
import RestingHeartRateChart from "./metric/RestingHeartRateChart";
import SleepTimeChart from "./metric/SleepTimeChart";
const Chart = (_a) => {
    var { metricType } = _a, props = __rest(_a, ["metricType"]);
    // I failed to get generics to work again without type assertion. I am ashamed.
    switch (metricType) {
        case MetricType.BloodOxygen:
            return (_jsx(BloodOxygenChart, Object.assign({}, props)));
        case MetricType.BloodPressure:
            return (_jsx(BloodPressureChart, Object.assign({}, props)));
        case MetricType.BloodSugar:
            return _jsx(BloodSugarChart, Object.assign({}, props));
        case MetricType.BodyMassIndex:
            return (_jsx(BodyMassIndexChart, Object.assign({}, props)));
        case MetricType.BodyTemperature:
            return (_jsx(BodyTemperatureChart, Object.assign({}, props)));
        case MetricType.BodyWeight:
            return _jsx(BodyWeightChart, Object.assign({}, props));
        case MetricType.DailySteps:
            return _jsx(DailyStepsChart, Object.assign({}, props));
        case MetricType.HeartRateVariability:
            return (_jsx(HeartRateVariabilityChart, Object.assign({}, props)));
        case MetricType.RestingHeartRate:
            return (_jsx(RestingHeartRateChart, Object.assign({}, props)));
        case MetricType.SleepTime:
            return _jsx(SleepTimeChart, Object.assign({}, props));
        default:
            return null;
    }
};
export default memo(Chart);
